export default {
      id: "icon-clipboard-usage",
      viewBox: "0 0 14 21",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-clipboard",
      toString: function () {
        return this.url;
      }
    }